import { render, staticRenderFns } from "./phoneNav.vue?vue&type=template&id=5c7a47d2&scoped=true&"
import script from "./phoneNav.vue?vue&type=script&lang=js&"
export * from "./phoneNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a47d2",
  null
  
)

export default component.exports